// extracted by mini-css-extract-plugin
export default {"wrapper":"_S-z","availablePromoMessagesLabel":"aT-z","promoMessageList":"bT-z","promoMessage":"cT-z","appliedPromoMessage":"dT-z","promoMessageAmount":"eT-z"};